import { CartService } from '../services/cart.service'


export function loadCart() {    
    return async dispatch => {
        const products = await CartService.loadCart()         
        dispatch({ type: 'SET_CART', products })
    }
}


export function updateCart(product, qiuckAdd, quant) {    
    return async dispatch => {
        const updatedProduct = await CartService.addToCart(product, qiuckAdd, quant)
        dispatch({ type: 'UPDATE_CART', updatedProduct })
    }
}

export function removeFromCart(product, quant) {
    return async dispatch => {
        const removedProduct = await CartService.removeFromCart(product)
        dispatch({ type: 'REMOVE_CART', removedProduct})
    }
}

